
export { useFormExtended } from "/home/jenkins/agent/workspace/web-sunrise-prod/web-sunrise-grandiaziende-deploy-prod/libs/consumer/hooks/src/lib/useFormExtended.ts"